export enum PLAN_STATUS {
  ACTIVE = "active",
  INACTIVE = "inactive",
}

export enum PLAN_TYPE {
  WEEKLY = "weekly",
  MONTHLY = "monthly",
  QUARTERLY = "quarterly",
  YEARLY = "yearly",
  BIENNALE = "biennale",
  TRIENNIAL = "triennial",
  THIRTYMONTHS = "thirtymonths",
  THIRTYFOURMONTHS = "thirtyfourmonths",
  THIRTYTHREEMONTHS = "thirtythreemonths",
  SEVENDAYS = "sevenDays",
  EXTSEVENDAYS = "extsevenDays",
  TWENTYTWODAYS = "twentyTwoDays"
}

export interface IPlan {
  _id: string;
  label: string;
  slug: string;
  value: number;
  deposit: number;
  months: number;
  planType: PLAN_TYPE;
  status: PLAN_STATUS;
}

export const emptyPlan = () =>
({
  _id: "",
  label: "Novo plano  - Mensal - R$ 99.99 / DIA",
  slug: "",
  value: 0,
  deposit: 600,
  months: 1,
  planType: PLAN_TYPE.MONTHLY,
  status: PLAN_STATUS.ACTIVE,
} as IPlan);

export const getPlanByLabel = (label: string) => {
  if (label === 'MENSAL') {
    return {
      label: label,
      value: PLAN_TYPE.MONTHLY,
      months: 1,
      days: 30,
    };
  } else if (label === 'TRIMESTRAL') {
    return {
      label: label,
      value: PLAN_TYPE.QUARTERLY,
      months: 3,
      days: 90,
    };
  }
  else if (label === 'Moto Club 7') {
    return {
      label: label,
      value: PLAN_TYPE.SEVENDAYS,
      months: 0,
      days: 7,
    };
  }
  else if (label === 'Extensão Moto Club +7') {
    return {
      label: label,
      value: PLAN_TYPE.EXTSEVENDAYS,
      months: 0,
      days: 7,
    };
  }
  else if (label === 'Moto Club 22') {
    return {
      label: label,
      value: PLAN_TYPE.TWENTYTWODAYS,
      months: 0,
      days: 22,
    };
  }
  else if (label === 'ANUAL') {
    return {
      label: label,
      value: PLAN_TYPE.YEARLY,
      months: 12,
      days: 365,
    };
  }
  else if (label === 'SV 0KM') {
    return {
      label: label,
      value: PLAN_TYPE.TRIENNIAL,
      months: 36,
      days: 1095,
    };
  }
  else if (label === 'SV 10KM') {
    return {
      label: label,
      value: PLAN_TYPE.THIRTYTHREEMONTHS,
      months: 33,
      days: 1003,
    };
  }
  else if (label === 'SV Semi') {
    return {
      label: label,
      value: PLAN_TYPE.THIRTYMONTHS,
      months: 33,
      days: 1003,
    };
  }
  else if (label === 'SV') {
    return {
      label: label,
      value: PLAN_TYPE.THIRTYFOURMONTHS,
      months: 34,
      days: 1029,
    };
  }
  else {
    return {
      label: label,
      value: PLAN_TYPE.BIENNALE,
      months: 24,
      days: 730,
    };
  }
}
